import { render, staticRenderFns } from "./UpdateLoginNotify.vue?vue&type=template&id=43cdfb80&scoped=true"
import script from "./UpdateLoginNotify.vue?vue&type=script&lang=js"
export * from "./UpdateLoginNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cdfb80",
  null
  
)

export default component.exports